<template>
  <v-card flat class="ma-0 d-flex flex-column" style="height:100%">
    <v-card-title class="primary white--text rounded-0 d-flex align-start py-1">
      Info Desk | Chat
    </v-card-title>
    <v-card-text
      class="chat-area d-flex flex-column-reverse grey lighten-4"
      :style="{ height: $vuetify.breakpoint.height - 114 + 'px' }"
    >
      <v-card v-for="message in session_message" :key="message.message_id" flat class="grey lighten-4">
        <v-list-item
          :key="message.message_id"
          v-if="message.attendee_id != myself.attendee_id"
          class=""
        >
          <v-list-item-avatar class="align-self-start mr-2 elevation-1">
            <v-avatar size="40">
              <v-img :src="message.attendee_data.profile_pic"></v-img>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content class="received-message">
            <v-card color="success" class="flex-none">
              <v-card-text class="white--text pa-2 d-flex flex-column">
                <span class="text-caption"
                  >{{ message.attendee_data.first_name }}
                  <v-icon
                    dark
                    title="Moderator"
                    v-if="message.add_by_attendee == 0"
                    size="10"
                    >mdi-shield-star-outline</v-icon
                  >
                </span>
                <span class="align-self-start text-subtitle-1">{{
                  message.message
                }}</span>
                <span class="text-caption font-italic align-self-end">{{
                  getTime(message.created_at)
                }}</span>
              </v-card-text>
            </v-card>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-else :key="message.message_id">
          <v-list-item-content class="sent-message justify-end">
            <v-card color="primary" class="flex-none">
              <v-card-text class="white--text pa-2 d-flex flex-column">
                <span class="text-subtitle-1 chat-message">{{
                  message.message
                }}</span>
                <span class="text-caption font-italic align-self-start">{{
                  getTime(message.created_at)
                }}</span>
              </v-card-text>
            </v-card>
          </v-list-item-content>
          <v-list-item-avatar class="align-self-start ml-2 elevation-1">
            <v-img :src="message.attendee_data.profile_pic"></v-img>
          </v-list-item-avatar>
        </v-list-item>
      </v-card>
    </v-card-text>
    <v-card-actions class="chat-footer success lighten-5 pa-0">
      <v-row class="d-flex flex-row justify-space-between" no-gutters>
        <v-col cols="12">
          <v-textarea
            placeholder="Type your message"
            v-model="new_message"
            @keydown.enter.exact.prevent
            @keyup.enter.exact="sendMessage()"
            @keydown.enter.shift.exact="newlineMessage"
            :loading="send_loading"
            hide-details=""
            rows="2"
            autofocus
            class="px-2"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "@/helper/axios";
import WsSubscriptions from "../../helper/websocket";
export default {
  name: "InfoDeskChat",
  data() {
    return {
      session_data: [],
      session_message: [],
      new_message: "",
      send_loading: false,
      socket_messages: [],
    };
  },
  computed: {
    myself() {
      return JSON.parse(localStorage.getItem("flaacos_user"));
    },
    newMessageWithoutSpace() {
      return this.new_message.trim();
    },
    messageLength() {
      return this.newMessageWithoutSpace.length;
    },
    reverse_messages() {
      let messages = this.session_message;
      let msgArray = [];
      for (let i = messages.length; i--; ) {
        msgArray.push(messages[i]);
      }
      return msgArray;
    },
  },
  methods: {
    setSocketMessage(data) {
      this.session_message.unshift(data);
    },
    getTime(time) {
      let msg_date = this.moment(time);
      let today = this.moment(new Date());
      if (msg_date.isSame(today, "day")) {
        return this.moment(time).format("hh:mm A");
      } else {
        return msg_date.format("DD, MMM hh:mm A");
      }
    },
    newlineMessage() {
      this.new_message = `${this.new_message}`;
    },
    sendMessage() {
      if (this.newMessageWithoutSpace.length) {
        this.send_loading = true;
        let data = {
          message: this.newMessageWithoutSpace,
          room_id: "infodesk:" + this.myself.attendee_id,
        };
        axios
          .post("/infodesk/add_message", data)
          .then(() => {
            this.new_message = "";
            // this.session_message.unshift(data.data.data)
          })
          .then(() => {
            this.send_loading = false;
          });
      }
    },
    getInfoDeskMessages() {
      axios
        .get("/infodesk/message_list", {
          params: {
            room_id: "infodesk:" + this.myself.attendee_id,
          },
        })
        .then((data) => {
          this.session_message = data.data.data;
        });
    },
  },
  async created() {
    await WsSubscriptions(this.myself.attendee_token);
  },
  mounted: function() {
    this.getInfoDeskMessages();
    let subscription = this.$ws.socket.getSubscription(
      `infodesk:${this.myself.attendee_id}`
    );
    if (!subscription) {
      this.$ws.subscribe(`infodesk:${this.myself.attendee_id}`);
      this.$ws.$on(
        `infodesk:${this.myself.attendee_id}|new_message`,
        this.setSocketMessage
      );
    } else {
      this.$ws.$on(
        `infodesk:${this.myself.attendee_id}|new_message`,
        this.setSocketMessage
      );
    }
  },
};
</script>

<style scoped>
.flex-none {
  flex: unset;
}
.chat-area {
  overflow-y: auto;
}
.received-message::after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: 54px;
  right: auto;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #4caf50 transparent transparent transparent;
}
.sent-message::after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: 54px;
  top: 12px;
  bottom: auto;
  border: 12px solid;
  border-color: #294c9e transparent transparent transparent;
}
</style>
